import { ShowButton, useTable, List, TextField } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import { Space, Table } from "antd";

import { LeagueDeptType } from "../../Lib";
import { AppImagePreview } from "components";
import { DeptsLinksDelete } from "./DeptsLinksDelete";

export function DepartmentsList() {
  const { push } = useNavigation();

  const { tableProps, searchFormProps } = useTable<LeagueDeptType[]>({
    dataProviderName: "departmentsTeamDataProvider",
    resource: "employees",
    meta: {},
    syncWithLocation: false,
    queryOptions: {
      enabled: true,
    },
  });

  const handleNavigateToEdit = (id: string) => {
    push(`/league-info/employees/team/show-dept/${id}`);
  };

  return (
    <List
      title={""}
      resource={"employees"}
      breadcrumb={false}
      canCreate={false}
      wrapperProps={{ style: { position: "sticky", top: 24 } }}
      headerButtons={<></>}
    >
      <Table
        {...tableProps}
        scroll={{ x: 1200 }}
        rowKey="id"
        locale={{
          emptyText: <div style={{ margin: 56 }}>Ссылки отсутствуют</div>,
        }}
        showSorterTooltip={false}
        pagination={false}
      >
        <Table.Column<LeagueDeptType>
          dataIndex={""}
          width={250}
          key="icon"
          title={"Иконка департамента"}
          render={(value) => {
            return <AppImagePreview imageURL={value.icon} useS3={true} />;
          }}
        />
        <Table.Column<LeagueDeptType>
          width={250}
          dataIndex={"title"}
          key="title"
          title="Наименование департамента"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column<LeagueDeptType>
          dataIndex={"description"}
          key="description"
          title="Описание"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column<LeagueDeptType>
          width={250}
          dataIndex={"name"}
          fixed={"right"}
          key="show"
          title="Действия"
          render={(_, record) => (
            <Space size={8} direction="vertical" style={{ width: "100%" }}>
              <ShowButton
                onClick={() => handleNavigateToEdit(String(record.id))}
                size={"small"}
                block
              >
                Смотреть / Редактировать
              </ShowButton>
              <DeptsLinksDelete id={Number(record.id)} name={record.title} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
}
